import { pageTitle } from 'ember-page-title';
import SiteHeader from 'devloed-website/components/site-header';
import SiteFooter from 'devloed-website/components/site-footer';

<template>
  {{pageTitle "DEVLOED.COM"}}

  <a href="#main-content" class="skip-link">
    Skip to main content
  </a>

  <div class="site-container">
    <SiteHeader />

    <main id="main-content" class="site-main">
      {{outlet}}
    </main>

    <SiteFooter />
  </div>
</template>
